module.exports = __webpack_public_path__ + "static/img/function-box-img2.f0ce0cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedProcess/function-box-img2.png
// module id = 3zTh
// module chunks = 0